import { useState } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button as MuiButton,
  styled,
  SxProps,
  Theme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import Icon from '@mdi/react'
import { mdiInformationSymbol } from '@mdi/js'

const Button = styled(MuiButton)(() => ({
  '&:hover': {
    backgroundColor: '#f5cf67',
  },
}))

interface InfoDialogProps {
  children: React.ReactNode
  label: string
  title: string
  buttonSx?: SxProps<Theme>
}

export const InfoDialog: React.FC<InfoDialogProps> = ({
  children,
  label,
  title,
  buttonSx,
}) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => setOpen(true)
  const handleClose = () => setOpen(false)

  // size needs to match the icon size and the button container
  // otherwise icon will use extra space and user will be able to click/hover outside of the icon
  // 'px' is required for the size prop for Safari
  const iconSize = 26

  return (
    <Box>
      <Button
        size="small"
        aria-label={label}
        sx={{
          height: iconSize,
          width: iconSize,
          minWidth: 0,
          borderRadius: '3px',
          backgroundColor: '#e0e0e0',
          p: 0,
          ...buttonSx,
        }}
        onClick={handleClick}
      >
        <Icon
          path={mdiInformationSymbol}
          size={`${iconSize}px`}
          color="#303c64"
        />
      </Button>

      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>{children}</DialogContent>
        <DialogActions>
          <MuiButton
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            OK
          </MuiButton>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
